module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAdBAMAAADWchiKAAAAMFBMVEU0hf8AAAA0hf80hf80hf80hf80hf80hf80hf80hf80hf80hf80hf80hf80hf80hf8jhGeaAAAAEHRSTlNNAAQ3SC0aIwoTRDs/Mh8NE66z0QAAALZJREFUKM80zLEJwmAYhOEXCQSDSD4VUko28McF0ohrOEIKCwsLU1gKprXSDcwmOoIjuEG+/0KufI47zGxxbmzINViOw5FugBup5AGpoKhIGpcCSP5xvAE6lxrQbAmQ5qwBdq2ZqtkpJzb7Mo4qh9afL5A1+gWCudQwNdMNmUX5QJCsYC55w0/i84nkCa3kDi9JBeUoQQKYcoDvKFuPpN9iIAPsBZDHQCJgEDBsRZQgABgXEIYCAISxLKaBYVH/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/symbol-left.png
// module id = cj2I
// module chunks = 0